module.exports = __webpack_public_path__ + "img/Betreuungsgruppe.f4163093.svg";